import classNames from "classnames";
import { useContext } from "react";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import { Icon } from "@livingmap/hippo";

import { MapContext } from "../../../Map/Map";

import SearchResultImage from "../SearchResultImage/SearchResultImage";

import styles from "./SearchResultGroup.module.scss";

export interface SearchResultProps {
  dataQA: string;
  className?: string;
  onClick: () => void;
  showImage: boolean;
  titleSearch: boolean;
  title: string;
  imageUrl: string | null;
}

export default function SearchResultGroup({
  dataQA,
  className,
  onClick,
  showImage,
  titleSearch,
  title,
  imageUrl,
}: SearchResultProps) {
  const { t } = useTranslation();
  const { controlTheme } = useContext(MapContext);

  return (
    <li
      data-qa={dataQA}
      className={classNames(styles.container, styles[controlTheme], className)}
      onClick={onClick}
    >
      {showImage && <SearchResultImage imageUrl={imageUrl} />}
      <div className={styles.content}>
        <div className={styles.info}>
          <p
            className={classNames(styles.name, {
              [styles.titleSearch]: titleSearch,
            })}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
          />
          <p className={styles.description}>
            {t("search_results.see_all_locations")}
          </p>
        </div>
        <div className={styles.iconContainer}>
          <Icon
            name="arrow_forward"
            size={24}
            dataQA="multiple-results-arrow-icon"
            className={styles.icon}
          />
        </div>
      </div>
    </li>
  );
}
